import { Component, Input, OnInit } from '@angular/core';
import { PopoverPlacement } from 'ngx-smart-popover';
import { Color } from '../../../constants/color.constants';
import { Icons } from '../../../constants/icons.constants';

/**
 * @group Basic Toolkit
 * @component Icon Popover
 *
 * @export
 * @class LsqIconPopoverComponent
 * @implements {OnInit}
 *
 * @property {string} [placement] Defines where the popover should appear relative to the icon. Defaults to `'bottom'`.
 * @property {string} [parentClass] Sets a class on the container `div`.
 * @property {string} [icon] The icon to display. Defaults to `'info'`.
 * @property {boolean} [hover] If `true`, popover will display on hover. Defaults to `false`.
 * @property {string} [titleText] Title to be rendered in the popup.
 * @property {string} [text] Text to be rendered in the popup.
 * @property {boolean} [isDark] Show the light or dark version.
 */

@Component({
    selector: 'lsq-icon-popover',
    template: `
        <lsq-icon
            [attr.tabindex]="tabindex"
            [type]="icon"
            [color]="color"
            [popoverOnHover]="hover"
            [popover]="text"
            [height]="height"
            [width]="width"
            [popoverTitle]="titleText"
            [popoverPlacement]="placement"
        >
        </lsq-icon>
    `,
    styleUrls: ['./lsq-icon-popover.component.scss']
})
export class LsqIconPopoverComponent implements OnInit {
    @Input() public placement = PopoverPlacement.Top;
    @Input() public parentClass?: string;
    @Input() public icon = Icons.Info;
    @Input() public text?: string;
    @Input() public width?: number;
    @Input() public height?: number;
    @Input() public titleText?: string;
    @Input() public hover = true;
    @Input() public isDark = false;
    @Input() public tabindex = 0;
    public color: Color = Color.Gray;

    ngOnInit(): void {
        if (this.isDark) {
            this.color = Color.GrayDarker;
        }
    }
}
